import { PropsWithChildren } from 'react';

import { useAddonsSitelockSsoV2 } from '@newfold/huapi-js';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface SitelockSSOProps extends BaseSsoProps {
  addonId: number | string;
}
const SitelockSSO = ({
  children = undefined,
  addonId,
  queryParams = {},
  disabled = false,
  ...props
}: PropsWithChildren<SitelockSSOProps>) => {
  const sso = useAddonsSitelockSsoV2(
    Number(addonId),
    queryParams,
    SSO_HOOK_OPTIONS,
  );

  return (
    <SSOComponent sso={sso} isDisabled={disabled} {...props}>
      {children}
    </SSOComponent>
  );
};

export default SitelockSSO;
